import { atom } from 'jotai';

/**
 * ProjectSourceSupabase - Stub for backward compatibility
 *
 * This file provides stub exports for components that haven't been fully migrated
 * from Firebase to the new D1/Clerk stack. These stubs prevent import errors
 * while the migration is completed.
 *
 * Files using these stubs:
 * - src/pages/Auth/ImpersonatorAuthPage.tsx
 * - src/pages/Auth/SignOutPage.tsx
 * - src/pages/Test/JotaiTestPage.tsx
 * - src/test/testUtils.tsx
 */

// Stub auth atom for backward compatibility
export const firebaseAuthAtom = atom({
  currentUser: null,
  signOut: async () => {
    console.warn('firebaseAuth.signOut() is deprecated. Use Clerk signOut instead.');
  },
});

// Stub database atom
export const firebaseDbAtom = atom({});

// Stub storage atom
export const firebaseStorageAtom = atom({});

// Default export for component usage
export default function ProjectSourceSupabase() {
  console.warn('ProjectSourceSupabase is a stub. Use ProjectSourceClerk for authentication.');
  return null;
}
